var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "m2.79 3.479 6.37 8.342-6.41 6.783h1.443l5.612-5.939 4.535 5.939h4.91l-6.729-8.812 5.967-6.313h-1.443l-5.169 5.468L7.7 3.48zm2.122 1.04h2.256l9.96 13.044h-2.256z"
  })));
};
export default SvgTwitter;